import { useMemo } from "react";
import { useSwingLibrarySettings } from "./useSwingLibrarySettings";
import {
  createFixedColumns,
  createDynamicIndicatorColumns,
} from "../components/Table/utils/columnHelpers";
import { VideoPathCell } from "../components/Table/cells/VideoPathCell";

export function useSwingTableColumns({
  collectionVideoIds,
  onVideoAction,
  videoPathAction = "none",
}) {
  const { data: swingLibrarySettings } = useSwingLibrarySettings();

  const fxdCols = useMemo(() => {
    const fixedCols = createFixedColumns();

    // Create videoPath column with appropriate action
    const videoPathColumn = {
      accessorKey: "videoPath",
      id: "videoPath",
      cell: ({ row }) => (
        <VideoPathCell
          actionType={videoPathAction}
          collectionVideoIds={collectionVideoIds}
          onAction={onVideoAction}
          row={row}
        />
      ),
      header: ({ table }) => (
        <VideoPathCell
          actionType={videoPathAction}
          isHeader={true}
          row={null}
          table={table}
        />
      ),
    };

    return [videoPathColumn, ...fixedCols];
  }, [videoPathAction, onVideoAction, collectionVideoIds]);

  const columns = useMemo(() => {
    const dynamicCols = createDynamicIndicatorColumns({
      savedIndicators: swingLibrarySettings?.savedIndicators ?? [],
      tourAveragesToggle: swingLibrarySettings?.tourAveragesToggle ?? false,
    });
    return [...fxdCols, ...dynamicCols];
  }, [
    fxdCols,
    swingLibrarySettings?.savedIndicators,
    swingLibrarySettings?.tourAveragesToggle,
  ]);

  return columns;
}
